import gsap from 'gsap';
import type { SlideUpFadeInOptions } from './slide.types';
import { fadeFromTo } from '../fade/fade';
import {
  defaultSlideHorizontallyOptions,
  defaultSlideOutOptions,
  defaultSlideUpFadeInOptions,
} from './slide.config';

export function slideOut(
  element: HTMLElement | Array<HTMLElement>,
  options: SlideUpFadeInOptions = {},
): gsap.core.Tween {
  const { duration, ease, stagger, to } = {
    ...defaultSlideOutOptions,
    ...options,
  };

  return gsap.to(element, { stagger, duration, y: to, ease });
}

export function slideUp(
  element: HTMLElement | Array<HTMLElement>,
  options: SlideUpFadeInOptions = {},
): gsap.core.Tween {
  const { duration, ease, from, stagger, to, clearProps } = {
    ...defaultSlideUpFadeInOptions,
    ...options,
  };
  return gsap.fromTo(element, { y: from }, { stagger, duration, clearProps, y: to, ease });
}

export function slideUpFadeIn(
  element: HTMLElement | Array<HTMLElement>,
  options: SlideUpFadeInOptions = {},
): gsap.core.Timeline {
  const mergedOptions = { ...defaultSlideUpFadeInOptions, ...options };
  const timeline = gsap.timeline();

  timeline.add(
    fadeFromTo(element, {
      duration: mergedOptions.duration,
      stagger: mergedOptions.stagger,
      ease: mergedOptions.ease,
      to: mergedOptions.fadeTo,
      autoAlpha: mergedOptions.autoAlpha,
      clearProps: mergedOptions.clearProps,
    }),
    0,
  );
  timeline.add(slideUp(element, mergedOptions), '<');
  return timeline;
}

export function slideHorizontally(
  element: HTMLElement | Array<HTMLElement>,
  options: SlideUpFadeInOptions = {},
): gsap.core.Tween {
  const { duration, ease, from, stagger, to, clearProps } = {
    ...defaultSlideHorizontallyOptions,
    ...options,
  };
  return gsap.fromTo(
    element,
    { x: from, willChange: 'transform' },
    { stagger, duration, clearProps, x: to, ease },
  );
}
